import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {SongDetailComponent} from '../';
import {AuthService} from '../../api/';
import {Helper} from '../../helper';
import {MdDialog, MdDialogRef} from '@angular/material';
import {AlbumsService} from '../../api';
import {Router} from '@angular/router';

@Component({
    selector: 'app-songitem-gridview-for-artist',
    templateUrl: './songitem-gridview-for-artist.component.html',
    styleUrls: ['./songitem-gridview-for-artist.component.css']
})
export class SongitemGridviewForArtistComponent implements OnInit {

    @Input() song: any;
    @Input() type: string = '';
    @Input() hideOptions: boolean = false;
    @Input() showDeleteSongFromPlaylist: boolean = false;
    @Output() refreshListing: EventEmitter<any> = new EventEmitter();
    dialogRef: MdDialogRef<SongDetailComponent>;
    album: any;
    private helper = new Helper();

    constructor(private authService: AuthService, public dialog: MdDialog, private albumService: AlbumsService, private router: Router) {

    }

    openSongDetail(event) {

        var width = '', height = '';
        var browserZoomLevel = Math.round(window.devicePixelRatio * 100);

        width = '37%';
        this.dialogRef = this.dialog.open(SongDetailComponent, {
            // disableClose: false,
            width: width
        });
        this.dialogRef.componentInstance.slug = this.song.slug;
        return false;
    }

    ngOnInit() {
    }

    handleSongDeleted() {
        this.song = '';
        this.refreshListing.emit({refresh: true});
    }

    routeToCollectionDetails() {
        this.router.navigate(['/collection', this.song.slug]);
    }

}



// WEBPACK FOOTER //
// ./src/app/songs/songitem-gridview-for-artist/songitem-gridview-for-artist.component.ts